export default __webpack_public_path__ + "static/media/ies_Current.5c78a279.png";